import { useEffect, useState } from 'react';
import CreateAction from '../../../components/operational/createAction';
import { Route, Router, useNavigate, useParams } from 'react-router-dom';
import { Surveys } from './Surveys';

const SurveyManager = ({ activeSurveys, setActiveSurveys }) => {

  const [activeSurveyType, setActiveSurveyType] = useState(null)

  useEffect(() => {
    const surveyType = activeSurveys?.[0]?.type
    setActiveSurveyType(surveyType)
  }, [activeSurveys])

  useEffect(() => {
    window.history.replaceState({}, "", "/surveys");
  }, [])
  const ActiveSurvey = Surveys[activeSurveyType]
  return (
    <>
      {ActiveSurvey && activeSurveys?.length > 0 &&

        <ActiveSurvey setActiveSurveys={setActiveSurveys}></ActiveSurvey>
      }
    </>
  );
};

export default SurveyManager;
